
(function(){
  'use strict';
  var listo = function(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); };

  listo(function(){
    /* ---------- 1. video del hero ---------- */
    document.querySelectorAll('video').forEach(function(v){
      v.muted = true; v.defaultMuted = true;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    });

    /* ---------- 2. carruseles ---------- */
    document.querySelectorAll('[data-aura-track]').forEach(function(track){
      var marco = track.parentElement;
      var paso = function(){
        var s = track.firstElementChild;
        if (!s) return track.clientWidth * 0.8;
        var r = s.getBoundingClientRect();
        var gap = parseFloat(getComputedStyle(track).columnGap || 0) || 0;
        return r.width + gap;
      };
      var mover = function(dir){ track.scrollBy({ left: dir * paso(), behavior: 'smooth' }); };

      var prev = marco.querySelector('[data-aura-prev]');
      var next = marco.querySelector('[data-aura-next]');
      if (prev) prev.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); mover(-1); });
      if (next) next.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); mover(1); });

      var pintarFlechas = function(){
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.style.opacity = track.scrollLeft <= 2 ? '.28' : '1';
        if (next) next.style.opacity = track.scrollLeft >= max ? '.28' : '1';
      };
      track.addEventListener('scroll', pintarFlechas, { passive: true });
      pintarFlechas();

      /* arrastrar con el mouse */
      var abajo = false, xIni = 0, sIni = 0;
      track.addEventListener('pointerdown', function(e){
        if (e.target.closest('a,button')) return;
        abajo = true; xIni = e.clientX; sIni = track.scrollLeft; track.style.scrollBehavior = 'auto';
      });
      track.addEventListener('pointermove', function(e){
        if (!abajo) return;
        var d = e.clientX - xIni;
        if (Math.abs(d) > 3) { track.scrollLeft = sIni - d; track.setPointerCapture(e.pointerId); }
      });
      ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
        track.addEventListener(ev, function(){ abajo = false; track.style.scrollBehavior = 'smooth'; });
      });

      /* teclado */
      track.setAttribute('tabindex','0');
      track.addEventListener('keydown', function(e){
        if (e.key === 'ArrowRight') { e.preventDefault(); mover(1); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); mover(-1); }
      });
    });

    /* ---------- 3. aparición al scrollear ---------- */
    var animables = document.querySelectorAll('[data-aura-rev]');
    if (!('IntersectionObserver' in window) || matchMedia('(prefers-reduced-motion: reduce)').matches) {
      animables.forEach(function(el){ el.classList.add('aura-visible'); });
    } else {
      var obs = new IntersectionObserver(function(entradas){
        entradas.forEach(function(en){
          if (!en.isIntersecting) return;
          var el = en.target;
          var i = +(el.getAttribute('data-aura-i') || 0);
          setTimeout(function(){ el.classList.add('aura-visible'); }, Math.min(i, 5) * 70);
          obs.unobserve(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
      animables.forEach(function(el){ obs.observe(el); });
    }
  });
})();

;

(function(){'use strict';
 var go=function(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);};
 go(function(){
  var b=document.querySelector('.nb'); if(!b) return;
  var q=function(s){return b.querySelector(s);};
  var qa=function(s){return Array.prototype.slice.call(b.querySelectorAll(s));};
  var MM=function(s,def){ try{ return window.matchMedia?matchMedia(s):{matches:def}; }catch(e){ return {matches:def}; } };
  var RM=MM('(prefers-reduced-motion: reduce)',false).matches;
  var IO='IntersectionObserver' in window;
  var mqDesk=MM('(min-width: 961px)',true), mqMob=MM('(max-width: 960px)',false), mqHover=MM('(hover: hover) and (pointer: fine)',false);
  var onMq=function(mq,fn){ if(mq.addEventListener) mq.addEventListener('change',fn); else if(mq.addListener) mq.addListener(fn); };
  var raf=window.requestAnimationFrame||function(f){return setTimeout(f,16);};
  var caf=window.cancelAnimationFrame||clearTimeout;

  /* ---------- datos ---------- */
  var P0=window.AURA_PRECIOS||{banda:4490,antes:6800,correa:745,lista:1490}, PLAN={p:P0.banda,a:P0.antes}, CORREA=P0.correa, LISTA=P0.lista, MAXC=6, STOCK=(window.AURA_STOCK||20), DUR=420;
  var COLS=window.AURA_COLS||{};
  var colOf=function(){var m=COLS[st.mat]||COLS.silicona;return m[st.color]||m[Object.keys(m)[0]];};
  var syncSw=function(){var m=COLS[st.mat];if(!m[st.color])st.color=Object.keys(m)[0];var swb=q('.nb__sw');if(swb)swb.classList.toggle('nb__sw--6',Object.keys(m).length>4);qa('[data-color]').forEach(function(b){var k=b.getAttribute('data-color'),c=m[k],w=b.parentElement;w.hidden=!c;if(!c)return;b.style.backgroundColor=c[1];b.setAttribute('aria-label',c[0]);var l=w.querySelector('span');if(l)l.textContent=c[0];var on=k===st.color;b.classList.toggle('on',on);w.classList.toggle('on',on);b.setAttribute('aria-checked',on?'true':'false');});};
  var st={addon:false,nc:1,color:(window.AURA_COL0||'azul'),mat:'silicona'}; window.AURA_ST=st;
  var fmt=function(x){return '$ '+Math.round(x).toLocaleString('es-UY');};
  var matName=function(){return st.mat==='tela'?'Tela':'Sport';};
  var setTxt=function(sel,txt){ var el=q(sel); if(el&&el.textContent!==txt) el.textContent=txt; return el; };
  var replay=function(el,cls){ if(!el||RM) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); };

  /* ---------- count-up con settle (≤450 ms, cierre exacto) ---------- */
  var tween=function(el,to,dur){
   if(!el) return;
   var has=el.hasAttribute('data-v'), from=has?(+el.getAttribute('data-v')||0):to;
   el.setAttribute('data-v',to);
   if(el._nbRaf){caf(el._nbRaf);el._nbRaf=0;}
   if(el._nbTo){clearTimeout(el._nbTo);el._nbTo=0;}
   if(RM||!dur||from===to){el.textContent=fmt(to);return;}
   var t0=null;
   var step=function(ts){
    if(t0===null) t0=ts;
    var p=Math.min(1,(ts-t0)/dur), e=1-Math.pow(1-p,3);
    if(p<1){ el.textContent=fmt(from+(to-from)*e); el._nbRaf=raf(step); }
    else { el._nbRaf=0; el.textContent=fmt(to); }
   };
   el._nbRaf=raf(step);
   el._nbTo=setTimeout(function(){ if(el._nbRaf){caf(el._nbRaf);el._nbRaf=0;} el.textContent=fmt(to); el._nbTo=0; },dur+80);
  };

  /* ---------- pintar estado ---------- */
  var lastTotal=null, incOn=false;
  var pintar=function(first){
   var extra=st.addon?CORREA*st.nc:0;
   var t=PLAN.p+extra, ant=PLAN.a+(st.addon?LISTA*st.nc:0), ah=ant-t, pct=Math.round((1-t/ant)*100);
   var cambio=lastTotal!==null&&lastTotal!==t;
   var col=colOf()[0], mn=matName();
   tween(q('[data-pre]'),t,first?0:DUR);
   setTxt('[data-ant]',fmt(ant));
   setTxt('[data-of]',window.AURA_OFERTA||('OFERTA — AHORRÁS '+pct+'%'));
   tween(q('[data-ahorro]'),ah,DUR);
   tween(q('[data-ah2]'),ah+(window.AURA_DESC_COD||0),first?0:DUR);
   /* CTA y barra sticky: siempre el valor final, nunca animado */
   var dc=window.AURA_DESC_COD||0; setTxt('[data-cta]',fmt(t-dc)); setTxt('[data-bart]',fmt(t-dc)); qa('[data-cta-s]').forEach(function(e){e.textContent=dc?fmt(t):'';});
   setTxt('[data-nc]',String(st.nc));
   var cm=q('[data-cmenos]'), cp=q('[data-cmas]');
   if(cm) cm.disabled=st.nc<=1; if(cp) cp.disabled=st.nc>=MAXC;
   var xn=q('[data-cxn]'); if(xn){ xn.hidden=!(st.nc>1); xn.textContent='× '+st.nc+' · '+fmt(CORREA*st.nc); }
   setTxt('[data-csum]','Correa '+mn+' · '+col+' × '+st.nc);
   setTxt('[data-prevname]',mn+' · '+col);
   var s2=q('[data-st2]'); if(s2){ s2.textContent=st.addon?(mn+' · '+col+' × '+st.nc):'Opcional'; s2.classList.toggle('on',st.addon); }
   var kx=q('[data-kitx]');
   if(kx){ kx.classList.toggle('on',st.addon); setTxt('[data-kitx-n]',st.nc+' × Correa '+mn+' · '+col); setTxt('[data-kitx-p]',fmt(CORREA*st.nc)); }
   setTxt('[data-kitn]',(4+(st.addon?st.nc:0))+' piezas');
   b.style.setProperty('--nb-strap',colOf()[1]);
   var src=(window.AURA_STRAPS||{})[(st.mat==='tela'?'tela':'sport')+'-'+st.color];if(src)qa('[data-strapimg]').forEach(function(im){if(im.getAttribute('src')!==src)im.setAttribute('src',src);});
   qa('.nb__strap').forEach(function(s){s.classList.toggle('nb__strap--tela',st.mat==='tela');});
   /* "Tu pedido incluye": la fila 3 sigue al add-on */
   var r3=q('[data-ir3]');
   if(r3){
    var was=r3.classList.contains('ok'), ok=st.addon&&incOn;
    r3.classList.toggle('ok',ok);
    setTxt('[data-ir3v]',st.addon?('−'+fmt(LISTA-CORREA)+(st.nc>1?' × '+st.nc:'')):'sumá correas');
    if(ok&&!was&&!first){ replay(r3,'nb-flash'); setTimeout(function(){r3.classList.remove('nb-flash');},360); }
   }
   if(cambio){ replay(q('[data-of]'),'nb-shine'); replay(q('[data-pre]'),'nb-pop'); }
   lastTotal=t;
  };

  /* ---------- plan (radio único) ---------- */
  qa('.nb__plan').forEach(function(p){ p.addEventListener('click',function(){
   qa('.nb__plan').forEach(function(y){y.classList.remove('on');y.setAttribute('aria-checked','false');});
   p.classList.add('on'); p.setAttribute('aria-checked','true'); }); });

  /* ---------- add-on ---------- */
  var wrap=q('.nb__addon-wrap'), btn=q('[data-addon]');
  if(btn) btn.addEventListener('click',function(){
   st.addon=!st.addon; wrap.classList.toggle('on',st.addon); btn.classList.toggle('on',st.addon);
   btn.setAttribute('aria-checked',st.addon?'true':'false'); pintar();});

  /* material */
  var matBox=q('.nb__mat');
  qa('[data-mat]').forEach(function(bt,i){
   bt.addEventListener('click',function(e){e.stopPropagation();
    qa('[data-mat]').forEach(function(y){y.classList.remove('on');y.setAttribute('aria-checked','false');});
    bt.classList.add('on'); bt.setAttribute('aria-checked','true'); st.mat=bt.getAttribute('data-mat');
    if(matBox) matBox.style.setProperty('--nb-mi',i); syncSw(); pintar();});
  });

  /* color */
  qa('[data-color]').forEach(function(s){
   s.addEventListener('click',function(e){e.stopPropagation();
    qa('[data-color]').forEach(function(y){y.classList.remove('on');y.setAttribute('aria-checked','false');y.parentElement.classList.remove('on');});
    s.classList.add('on'); s.setAttribute('aria-checked','true'); s.parentElement.classList.add('on');
    st.color=s.getAttribute('data-color'); pintar();});
  });

  /* cantidad */
  var cmenos=q('[data-cmenos]'), cmas=q('[data-cmas]'), ncEl=q('[data-nc]');
  var setN=function(n){ if(n<1||n>MAXC) return; st.nc=n; replay(ncEl,'nb-tick'); pintar(); };
  if(cmenos) cmenos.addEventListener('click',function(e){e.stopPropagation(); setN(st.nc-1);});
  if(cmas) cmas.addEventListener('click',function(e){e.stopPropagation(); setN(st.nc+1);});

  /* ---------- galería: dos capas, precarga y swap en onload ---------- */
  var marco=q('.nb__marco'), phs=qa('.nb__ph'), tira=q('.nb__tira'), cnt=q('[data-cnt]');
  var thumbs=qa('.nb__t'), bullets=qa('.nb__bi');
  var capa=0, actual=0, token=0;
  var marcarBullet=function(key){ bullets.forEach(function(x){ x.classList.toggle('on', !!key && x.getAttribute('data-foto')===key); }); };
  var irA=function(i,desdeBullet){
   if(i<0||i>=thumbs.length||phs.length<2) return;
   var t=thumbs[i], src=t.getAttribute('data-full');
   thumbs.forEach(function(y,j){y.classList.toggle('on',j===i);});
   if(cnt) cnt.textContent=(i<9?'0':'')+(i+1);
   if(!desdeBullet && mqDesk.matches) marcarBullet(t.getAttribute('data-key'));
   if(tira){ var r=t.getBoundingClientRect(), tr=tira.getBoundingClientRect();
    if(r.left<tr.left||r.right>tr.right) tira.scrollBy({left:r.left-tr.left-(tr.width-r.width)/2,behavior:RM?'auto':'smooth'}); }
   if(i===actual) return;
   actual=i;
   var cur=phs[capa], nxt=phs[1-capa], my=++token;
   var swap=function(){
    if(my!==token) return;
    nxt.classList.add('on'); cur.classList.remove('on');
    nxt.removeAttribute('aria-hidden'); nxt.alt='Aura Band 2.0';
    cur.setAttribute('aria-hidden','true'); cur.alt='';
    capa=1-capa;
   };
   if(nxt.getAttribute('src')===src&&nxt.complete&&nxt.naturalWidth){ swap(); return; }
   nxt.onload=swap; nxt.onerror=swap; nxt.src=src;
   if(nxt.complete&&nxt.naturalWidth) swap();
  };
  thumbs.forEach(function(t,i){ t.addEventListener('click',function(){ irA(i,false); }); });
  var mv=function(d){ if(!tira) return; var w=(thumbs[0]?thumbs[0].getBoundingClientRect().width:74)+10; tira.scrollBy({left:d*w*2,behavior:RM?'auto':'smooth'}); };
  var fp=q('[data-tprev]'), fn=q('[data-tnext]');
  if(fp) fp.addEventListener('click',function(){mv(-1);});
  if(fn) fn.addEventListener('click',function(){mv(1);});
  if(phs[1]&&thumbs[1]) phs[1].src=thumbs[1].getAttribute('data-full');

  /* ---------- bullets ↔ galería (solo desktop; hover con 180 ms o click) ---------- */
  var porKey=function(k){ for(var i=0;i<thumbs.length;i++){ if(thumbs[i].getAttribute('data-key')===k) return i; } return -1; };
  var hoverT=0;
  var activar=function(li){ if(!mqDesk.matches) return; var i=porKey(li.getAttribute('data-foto')); if(i<0) return; marcarBullet(li.getAttribute('data-foto')); irA(i,true); };
  var setBullets=function(){ var on=mqDesk.matches; bullets.forEach(function(x){ x.disabled=!on; x.classList.toggle('nb-sync',on); if(!on) x.classList.remove('on'); }); };
  bullets.forEach(function(li){
   li.addEventListener('click',function(){ clearTimeout(hoverT); activar(li); });
   if(mqHover.matches){
    li.addEventListener('pointerenter',function(){ clearTimeout(hoverT); hoverT=setTimeout(function(){activar(li);},180); });
    li.addEventListener('pointerleave',function(){ clearTimeout(hoverT); });
   }
  });
  setBullets(); onMq(mqDesk,setBullets);

  /* ---------- tilt 3D (puntero fino, rect cacheado, máx 3°, sin reflejo) ---------- */
  var stage=q('.nb__stage');
  if(stage&&marco&&!RM&&mqHover.matches){
   var pend=0, rx=0, ry=0, rect=null, MAX=3;
   var apply=function(){ pend=0; marco.style.transform='rotateX('+rx.toFixed(2)+'deg) rotateY('+ry.toFixed(2)+'deg)'; };
   stage.addEventListener('pointerenter',function(){ rect=marco.getBoundingClientRect(); marco.classList.add('nb-hover'); });
   stage.addEventListener('pointermove',function(e){
    if(!rect||!rect.width) return;
    var px=Math.min(1,Math.max(0,(e.clientX-rect.left)/rect.width)), py=Math.min(1,Math.max(0,(e.clientY-rect.top)/rect.height));
    ry=(px-.5)*2*MAX; rx=(.5-py)*2*MAX;
    if(!pend) pend=raf(apply); });
   stage.addEventListener('pointerleave',function(){ rect=null; marco.classList.remove('nb-hover'); rx=0; ry=0; if(!pend) pend=raf(apply); });
  }

  /* ---------- escasez segmentada: N segmentos según ancho, los 20 de la derecha encendidos ---------- */
  var seg=q('[data-seg]');
  if(seg){
   var built=0, lit=false;
   var build=function(){
    var w=seg.clientWidth; if(!w) return;
    var n=window.AURA_STOCK_TOTAL||Math.max(STOCK+6,Math.floor((w+3)/9)); if(n===built) return; built=n;
    var h=''; for(var i=0;i<n;i++) h+=(i>=n-STOCK)?('<b class="nb__seg-q'+(lit?' on':'')+'"></b>'):'<b></b>';
    seg.innerHTML=h;
   };
   var encender=function(){
    if(lit) return; lit=true;
    qa('[data-seg] .nb__seg-q').forEach(function(c,k){ if(RM){c.classList.add('on');return;} setTimeout(function(){c.classList.add('on');},40*k+140); });
   };
   build();
   if(IO&&!RM){ var so=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){encender();so.disconnect();}});},{threshold:.5}); so.observe(seg); }
   else encender();
   var rt=0; window.addEventListener('resize',function(){clearTimeout(rt); rt=setTimeout(build,150);},{passive:true});
  }

  /* ---------- "Tu pedido incluye": ticks en secuencia, una vez, al entrar en viewport ---------- */
  var inc=q('[data-inc]');
  var revelarInc=function(){
   if(incOn) return; incOn=true;
   qa('[data-inc] .nb__ir').forEach(function(r,k){
    var f=function(){ if(k<2||st.addon) r.classList.add('ok'); if(k===2) pintar(); };
    if(RM) f(); else setTimeout(f,150*k+80);
   });
  };
  if(inc){ if(IO&&!RM){ var oi=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){revelarInc();oi.disconnect();}});},{threshold:.6}); oi.observe(inc); } else revelarInc(); }

  /* ---------- FAQ (uno abierto a la vez) ---------- */
  qa('.nb__ab').forEach(function(x){x.addEventListener('click',function(){
   var it=x.parentElement, ab=it.classList.contains('on');
   qa('.nb__ai').forEach(function(y){y.classList.remove('on'); var bb=y.querySelector('.nb__ab'); if(bb) bb.setAttribute('aria-expanded','false');});
   if(!ab){ it.classList.add('on'); x.setAttribute('aria-expanded','true'); }
  });});

  /* ---------- UGC: click reproduce/pausa (muted), uno a la vez; pausa lo que arranca el runtime ---------- */
  var cards=qa('.nb__ugc-c');
  var pausar=function(c){ c.classList.remove('play'); var v=c.querySelector('video'); if(v) v.pause(); };
  cards.forEach(function(c){
   var v=c.querySelector('video');
   if(v){ v.muted=true; try{v.pause();}catch(e){} v.addEventListener('play',function(){ if(!c.classList.contains('play')) v.pause(); }); }
   c.addEventListener('click',function(){
    cards.forEach(function(o){ if(o!==c) pausar(o); });
    if(c.classList.contains('play')){ pausar(c); return; }
    c.classList.add('play'); if(!v) return;
    v.muted=true; try{v.currentTime=0;}catch(e){}
    var p=v.play(); if(p&&p.catch) p.catch(function(){});
   });
  });

  /* ---------- cinta: pausa fuera de viewport ---------- */
  var pista=q('.nb__pista');
  if(pista&&IO){
   var io=new IntersectionObserver(function(es){es.forEach(function(e){pista.style.animationPlayState=e.isIntersecting?'running':'paused';});},{threshold:0});
   io.observe(pista.parentElement||pista);
  }

  /* ---------- barra sticky de compra (mobile): solo cuando el CTA salió por arriba ---------- */
  var barm=q('[data-barm]'), cta=q('.nb__cta'), barcta=q('[data-barcta]');
  if(barm&&cta&&IO){
   var ctaArriba=false, nbVis=true, barPend=0;
   var pintarBar=function(){
    var on=mqMob.matches&&ctaArriba&&nbVis&&window.scrollY>240;
    barm.classList.toggle('show',on); barm.setAttribute('aria-hidden',on?'false':'true');
    if(barcta) barcta.tabIndex=on?0:-1;
   };
   /* medición directa (respaldo del IO, una lectura por frame de scroll) */
   var medir=function(){
    barPend=0;
    var r=cta.getBoundingClientRect(), rb=b.getBoundingClientRect(), vh=window.innerHeight||0;
    ctaArriba=r.bottom<72; nbVis=rb.bottom>140&&rb.top<vh-140; pintarBar();
   };
   new IntersectionObserver(function(es){es.forEach(function(e){ ctaArriba=!e.isIntersecting&&e.boundingClientRect.top<72; });pintarBar();},{threshold:0,rootMargin:'-72px 0px 0px 0px'}).observe(cta);
   new IntersectionObserver(function(es){es.forEach(function(e){nbVis=e.isIntersecting;});pintarBar();},{threshold:0,rootMargin:'0px 0px -140px 0px'}).observe(b);
   window.addEventListener('scroll',function(){ if(!barPend) barPend=raf(medir); },{passive:true});
   onMq(mqMob,pintarBar);
   if(barcta) barcta.addEventListener('click',function(){ cta.scrollIntoView({block:'center',behavior:RM?'auto':'smooth'}); try{cta.focus({preventScroll:true});}catch(e){} });
  }

  syncSw(); pintar(true);
 });
})();

;

;

;

(function(){'use strict';
 var go=function(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);};
 go(function(){
  var btn=document.querySelector('header [class*=mobile-navigation-button]'); if(!btn) return;
  var links=[].slice.call(document.querySelectorAll('header ul[class*=navigation-items--desktop] li a')).slice(0,4);
  var cta=document.querySelector('header a.aura-navcta');
  var m=document.createElement('div'); m.className='aura-mnav'; m.id='aura-mnav'; m.setAttribute('aria-hidden','true');
  var arrow='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  m.innerHTML='<ul>'+links.map(function(a){return '<li><a href="'+a.getAttribute('href')+'">'+a.textContent.trim()+arrow+'</a></li>';}).join('')+'</ul>'+
   '<div class="aura-mnav__pie"><a class="aura-mnav__cta" href="'+(cta?cta.getAttribute('href'):'#')+'">Empezar</a><p class="aura-mnav__nota">Envío 24-48 h · App incluida · Sin suscripción</p></div>';
  document.body.appendChild(m);
  btn.setAttribute('aria-label','Abrir menú'); btn.setAttribute('aria-expanded','false'); btn.setAttribute('aria-controls','aura-mnav');
  var abierto=false;
  var set=function(v){abierto=v; document.documentElement.classList.toggle('aura-mnav-open',v);
   btn.setAttribute('aria-expanded',v?'true':'false'); btn.setAttribute('aria-label',v?'Cerrar menú':'Abrir menú'); m.setAttribute('aria-hidden',v?'false':'true');};
  btn.addEventListener('click',function(e){e.preventDefault();e.stopPropagation();set(!abierto);});
  m.addEventListener('click',function(e){if(e.target.closest('a')) set(false);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'&&abierto) set(false);});
  var mq=window.matchMedia('(min-width:961px)'); var onmq=function(){if(mq.matches&&abierto) set(false);};
  if(mq.addEventListener) mq.addEventListener('change',onmq); else if(mq.addListener) mq.addListener(onmq);
 });
})();

;

(function(){'use strict';
 var go=function(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);};
 go(function(){
  var v=document.querySelector('.ahero__vid'); if(!v) return;
  var rel=v.getAttribute('data-src'), abs=v.getAttribute('data-src-abs');
  var pr=v.getAttribute('data-poster'), pabs=v.getAttribute('data-poster-abs');
  var base=/^(https?|file):/.test(document.location.protocol||'')?document.location.href:null;
  var url=function(r,a){ if(base){ try{ return new URL(r,base).href; }catch(e){} } return a||r; };
  v.poster=url(pr,pabs); v.src=url(rel,abs);
  v.muted=true; v.loop=true; v.playsInline=true;
  var arranca=function(){ var q=v.play(); if(q&&q.catch) q.catch(function(){}); };
  if('IntersectionObserver' in window){
   new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?arranca():v.pause(); });},{threshold:.15}).observe(v);
  } else arranca();
  v.addEventListener('loadeddata',arranca);
 });
})();

;
(function(){'use strict';
 var go=function(f){document.readyState!=='loading'?f():document.addEventListener('DOMContentLoaded',f);};
 go(function(){
  var box=document.querySelector('.nb--c [data-specs]'); if(!box) return;
  var RM=false; try{RM=matchMedia('(prefers-reduced-motion: reduce)').matches;}catch(e){}
  var raf=window.requestAnimationFrame||function(f){return setTimeout(f,16);};
  var nums=[].slice.call(box.querySelectorAll('[data-count]')), done=false;
  var run=function(){
   if(done) return; done=true; box.classList.add('on');
   nums.forEach(function(el,k){
    var to=+el.getAttribute('data-count')||0, dur=950;
    if(RM||!to){ el.textContent=String(to); return; }
    var t0=null;
    var step=function(ts){ if(t0===null) t0=ts; var p=Math.min(1,(ts-t0)/dur), e=1-Math.pow(1-p,3); el.textContent=String(Math.round(to*e)); if(p<1) raf(step); else el.textContent=String(to); };
    setTimeout(function(){ raf(step); },140*k);
   });
  };
  if('IntersectionObserver' in window&&!RM){ var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ run(); io.disconnect(); } });},{threshold:.35}); io.observe(box); }
  else run();
 });
})();

;

(function(){
  var r=document.querySelector('[data-acar]'); if(!r) return;
  var p=document.querySelector('[data-acar-p]'), n=document.querySelector('[data-acar-n]');
  var ds=[].slice.call(document.querySelectorAll('[data-acar-d] .acar__d'));
  var cs=[].slice.call(r.children);
  var paso=function(){ var a=cs[0], b=cs[1]; return b ? b.offsetLeft-a.offsetLeft : r.clientWidth; };
  var idx=function(){ return Math.round(r.scrollLeft/paso()); };
  var pintar=function(){
    var max=r.scrollWidth-r.clientWidth-2, i=idx();
    if(p) p.disabled=r.scrollLeft<=2;
    if(n) n.disabled=r.scrollLeft>=max;
    var ult=r.scrollLeft>=max ? ds.length-1 : i;
    ds.forEach(function(d,k){ d.classList.toggle('on',k===Math.min(ult,ds.length-1)); d.setAttribute('aria-current',k===ult?'true':'false'); });
  };
  var ir=function(i){ r.scrollTo({left:i*paso()}); };
  if(p) p.addEventListener('click',function(){ ir(Math.max(0,idx()-1)); });
  if(n) n.addEventListener('click',function(){ ir(idx()+1); });
  ds.forEach(function(d,k){ d.addEventListener('click',function(){ ir(k); }); });
  r.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){e.preventDefault();ir(idx()+1);} if(e.key==='ArrowLeft'){e.preventDefault();ir(Math.max(0,idx()-1));} });
  var t=0; r.addEventListener('scroll',function(){ cancelAnimationFrame(t); t=requestAnimationFrame(pintar); },{passive:true});
  window.addEventListener('resize',pintar); pintar();
})();
